import { useState, useCallback } from "react"
import { fileCache, tokenCache } from "../util/file-cache.js"

export function useFileContent(baseURL) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const loadFileContent = useCallback(
    async (file, user, forceRefresh = false) => {
      if (!file || !user) return null

      setLoading(true)
      setError(null)

      try {
        const userId = user.uid

        // Intentar obtener del cache primero (a menos que se fuerce refresh)
        if (!forceRefresh) {
          const cachedContent = fileCache.get(file.r2Key, userId)
          if (cachedContent) {
            setLoading(false)
            return cachedContent
          }
        }

        // Si no está en cache, hacer petición
        console.log(`🌐 Petición HTTP para ${file.fileName}`)

        const token = await tokenCache.getToken(user)

        const response = await fetch(`${baseURL}/view/${encodeURIComponent(file.r2Key)}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
        })

        if (!response.ok) {
          throw new Error("Error al cargar el archivo")
        }

        const data = await response.json()

        // Guardar en cache
        fileCache.set(file.r2Key, userId, data.url)

        setLoading(false)
        return data.url
      } catch (err) {
        console.error("❌ Error cargando contenido:", err)
        setError(err.message)
        setLoading(false)
        return null
      }
    },
    [baseURL],
  )

  const invalidateCache = useCallback((file, user) => {
    if (file && user) {
      fileCache.invalidate(file.r2Key, user.uid)
    }
  }, [])

  return {
    loadFileContent,
    invalidateCache,
    loading,
    error,
    cacheStats: fileCache.getStats(),
  }
}
